export default "__VITE_ASSET__BimJLI1R__"